/** @jsxImportSource theme-ui */
import React from "react";
import { jsx } from "theme-ui";
import { Grid } from "@theme-ui/components";
import { GatsbyImage } from "gatsby-plugin-image";

const SocialProof = ({ CustomerLogos }) => {
  return (
    <Grid
      sx={{
        gridTemplateColumns: [
          "repeat(2, 1fr)",
          "repeat(2, 1fr)",
          "repeat(3, 1fr)",
          "repeat(5, 1fr)",
        ],
        gap: "3rem",
      }}
    >
      {CustomerLogos?.nodes?.map(
        ({ companyLogo, companyLogoAltText }, index) =>
          companyLogo && (
            <GatsbyImage
              key={`customer-${index}`}
              image={companyLogo.gatsbyImageData}
              imgStyle={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              alt={companyLogoAltText}
            />
          )
      )}
    </Grid>
  );
};

export default SocialProof;
